import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as addResourceGroup from "./addResourceGroup";
import * as addResourceToResourceGroup from "./addResourceToResourceGroup";
import * as editResourceGroup from "./editResourceGroup";
import * as removeResourceFromResourceGroup from "./removeResourceFromResourceGroup";
import * as addEveryoneToResourceGroup from "./addEveryoneToResourceGroup";
import * as removeResourceGroup from "./removeResourceGroup";
import * as retrieveResourceGroup from "./retrieveResourceGroup";
import * as retrieveResourceGroups from "./retrieveResourceGroups";

const initialState: State = {
  addResourceGroup: addResourceGroup.initialState,
  addResourceToResourceGroup: addResourceToResourceGroup.initialState,
  editResourceGroup: editResourceGroup.initialState,
  removeResourceFromResourceGroup: removeResourceFromResourceGroup.initialState,
  addEveryoneToResourceGroup: addEveryoneToResourceGroup.initialState,
  removeResourceGroup: removeResourceGroup.initialState,
  retrieveResourceGroup: retrieveResourceGroup.initialState,
  retrieveResourceGroups: retrieveResourceGroups.initialState,
};

const reduceState = combineStateReducer(initialState, {
  addResourceGroup: addResourceGroup.reduceState,
  addResourceToResourceGroup: addResourceToResourceGroup.reduceState,
  editResourceGroup: editResourceGroup.reduceState,
  removeResourceFromResourceGroup: removeResourceFromResourceGroup.reduceState,
  addEveryoneToResourceGroup: addEveryoneToResourceGroup.reduceState,
  removeResourceGroup: removeResourceGroup.reduceState,
  retrieveResourceGroup: retrieveResourceGroup.reduceState,
  retrieveResourceGroups: retrieveResourceGroups.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...addResourceGroup.createSelector(() => getState().addResourceGroup),
    ...addResourceToResourceGroup.createSelector(
      () => getState().addResourceToResourceGroup,
    ),
    ...editResourceGroup.createSelector(() => getState().editResourceGroup),
    ...removeResourceFromResourceGroup.createSelector(
      () => getState().removeResourceFromResourceGroup,
    ),
    ...addEveryoneToResourceGroup.createSelector(
      () => getState().addEveryoneToResourceGroup,
    ),
    ...removeResourceGroup.createSelector(() => getState().removeResourceGroup),
    ...retrieveResourceGroup.createSelector(
      () => getState().retrieveResourceGroup,
    ),
    ...retrieveResourceGroups.createSelector(
      () => getState().retrieveResourceGroups,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
